var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4193 10.5417V13.6251C15.4193 16.2251 12.9943 18.3334 10.0026 18.3334C7.01094 18.3334 4.58594 16.2251 4.58594 13.6251V10.5417C4.58594 13.1417 7.01094 15.0001 10.0026 15.0001C12.9943 15.0001 15.4193 13.1417 15.4193 10.5417Z",
    fill: "#005057"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.4193 6.375V10.5417C15.4193 13.1417 12.9943 15 10.0026 15C7.01094 15 4.58594 13.1417 4.58594 10.5417V6.375C4.58594 7.13333 4.79427 7.83333 5.16094 8.43333C6.05261 9.9 7.88594 10.8333 10.0026 10.8333C12.1193 10.8333 13.9526 9.9 14.8443 8.43333C15.2109 7.83333 15.4193 7.13333 15.4193 6.375Z",
    fill: "#005057"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4193 6.37484C15.4193 7.13317 15.2109 7.83317 14.8443 8.43317C13.9526 9.89984 12.1193 10.8332 10.0026 10.8332C7.88594 10.8332 6.05261 9.89984 5.16094 8.43317C4.79427 7.83317 4.58594 7.13317 4.58594 6.37484C4.58594 3.77484 7.01094 1.6665 10.0026 1.6665C11.5026 1.6665 12.8526 2.1915 13.8359 3.0415C14.8109 3.89984 15.4193 5.07484 15.4193 6.37484Z",
    fill: "#005057"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.042c8c16.svg";
export { ForwardRef as ReactComponent };